<template>
    <md-dialog :md-closed="closeDialog" :md-opened="openDialog" class="poi-dialog" :md-close-on-esc="false"
               :md-click-outside-to-close="false"
               :md-active.sync="options.showPOIForm">
      <md-dialog-title class="poi-dialog__title">{{
          currentFormPOI ? options.Lang.POI_bearbeiten : options.Lang.Neuen_POI_anlegen
        }}
      </md-dialog-title>

      <md-dialog-content class="poi-dialog__content">
        <form novalidate class="poi-form" @submit.prevent="validate">

          <!-- ===================== BASICS ===================== -->
          <fieldset class="poi-section">
            <legend class="poi-section__title">{{ options.Lang.poiSectionBasics }}</legend>
            <div class="poi-grid">
              <div class="poi-field poi-field--half">
                <label class="poi-label" for="name">
                  {{ options.Lang.poiName }}<span class="poi-required">*</span>
                </label>
                <input
                    id="name" name="name" type="text" tabindex="2"
                    class="poi-input"
                    :class="{ 'poi-input--error': $v.form.name.$dirty && !$v.form.name.required }"
                    :placeholder="options.Lang.Name"
                    v-model="form.name"
                    :disabled="sending || !options.POIFormEditable" />
                <span class="poi-error" v-if="$v.form.name.$dirty && !$v.form.name.required">
                  {{ options.Lang.Bitte_ausfüllen }}
                </span>
              </div>

              <div class="poi-field poi-field--quarter">
                <label class="poi-label" for="latitud">
                  {{ options.Lang.poiLatitud }}<span class="poi-required">*</span>
                </label>
                <input
                    id="latitud" name="latitud" type="text" tabindex="2"
                    class="poi-input"
                    :placeholder="options.Lang.poiLatitud"
                    v-model="form.latitud"
                    :disabled="sending || !options.POIFormEditable" />
              </div>

              <div class="poi-field poi-field--quarter">
                <label class="poi-label" for="longitude">
                  {{ options.Lang.poilongitud }}<span class="poi-required">*</span>
                </label>
                <input
                    id="longitude" name="longitude" type="text" tabindex="2"
                    class="poi-input"
                    :placeholder="options.Lang.poilongitud"
                    v-model="form.longitude"
                    :disabled="sending || !options.POIFormEditable" />
              </div>
            </div>
          </fieldset>

          <!-- ===================== ADDRESS ===================== -->
          <fieldset class="poi-section">
            <legend class="poi-section__title">{{ options.Lang.poiSectionAddress }}</legend>
            <div class="poi-grid">
              <div class="poi-field poi-field--half">
                <label class="poi-label" for="address_line_1">{{ options.Lang.poiAddressLine1 }}</label>
                <input id="address_line_1" name="address_line_1" type="text" tabindex="2" class="poi-input"
                       :placeholder="options.Lang.poiAddressLine1" v-model="form.address_line_1"
                       :disabled="sending || !options.POIFormEditable" />
              </div>
              <div class="poi-field poi-field--half">
                <label class="poi-label" for="address_line_2">{{ options.Lang.poiAddressLine2 }}</label>
                <input id="address_line_2" name="address_line_2" type="text" tabindex="2" class="poi-input"
                       :placeholder="options.Lang.poiAddressLine2" v-model="form.address_line_2"
                       :disabled="sending || !options.POIFormEditable" />
              </div>

              <div class="poi-field poi-field--quarter">
                <label class="poi-label" for="zip_code">{{ options.Lang.poiZipCode }}</label>
                <input id="zip_code" name="zip_code" type="text" tabindex="2" class="poi-input"
                       :placeholder="options.Lang.poiZipCode" v-model="form.zip_code"
                       :disabled="sending || !options.POIFormEditable" />
              </div>
              <div class="poi-field poi-field--quarter">
                <label class="poi-label" for="city">{{ options.Lang.poiCity }}</label>
                <input id="city" name="city" type="text" tabindex="2" class="poi-input"
                       :placeholder="options.Lang.poiCity" v-model="form.city"
                       :disabled="sending || !options.POIFormEditable" />
              </div>
              <div class="poi-field poi-field--quarter">
                <label class="poi-label" for="state">{{ options.Lang.poiState }}</label>
                <input id="state" name="state" type="text" tabindex="2" class="poi-input"
                       :placeholder="options.Lang.poiState" v-model="form.state"
                       :disabled="sending || !options.POIFormEditable" />
              </div>
              <div class="poi-field poi-field--quarter">
                <label class="poi-label" for="country">{{ options.Lang.poiCountry }}</label>
                <input id="country" name="country" type="text" tabindex="2" class="poi-input"
                       :placeholder="options.Lang.poiCountry" v-model="form.country"
                       :disabled="sending || !options.POIFormEditable" />
              </div>
            </div>
          </fieldset>

          <!-- ===================== CONTACT ===================== -->
          <fieldset class="poi-section">
            <legend class="poi-section__title">{{ options.Lang.poiSectionContact }}</legend>
            <div class="poi-grid">
              <div class="poi-field poi-field--half">
                <label class="poi-label" for="poiWebsite">{{ options.Lang.poiWebsite }}</label>
                <input id="poiWebsite" name="website" type="text" tabindex="2" class="poi-input"
                       placeholder="www.placewebsite1.com, www.placewebsite2.co" v-model="form.website"
                       :disabled="sending || !options.POIFormEditable" />
              </div>
              <div class="poi-field poi-field--half">
                <label class="poi-label" for="poiemail">{{ options.Lang.poiemail }}</label>
                <input id="poiemail" name="email" type="text" tabindex="2" class="poi-input"
                       placeholder="oneemail@email.com, another@email.com" v-model="form.email"
                       :disabled="sending || !options.POIFormEditable" />
              </div>

              <div class="poi-field poi-field--quarter">
                <label class="poi-label" for="poiTelephone">{{ options.Lang.poiTelephone }}</label>
                <input id="poiTelephone" name="telephone" type="text" tabindex="2" class="poi-input"
                       placeholder="+1-123-456-7890" v-model="form.telephone"
                       :disabled="sending || !options.POIFormEditable" />
              </div>
              <div class="poi-field poi-field--quarter">
                <label class="poi-label" for="poiFreeCall">{{ options.Lang.poiFreeCall }}</label>
                <input id="poiFreeCall" name="freeCall" type="text" tabindex="2" class="poi-input"
                       placeholder="+1-800-123-4567" v-model="form.freeCall"
                       :disabled="sending || !options.POIFormEditable" />
              </div>
              <div class="poi-field poi-field--half">
                <label class="poi-label" for="poiOpeningTimes">{{ options.Lang.poiOpeningTimes }}</label>
                <input id="poiOpeningTimes" name="openTimes" type="text" tabindex="2" class="poi-input"
                       placeholder="mon-sat: 8am-9pm" v-model="form.openTimes"
                       :disabled="sending || !options.POIFormEditable" />
              </div>
            </div>
          </fieldset>

          <!-- ===================== CONTENT ===================== -->
          <fieldset class="poi-section">
            <legend class="poi-section__title">{{ options.Lang.poiSectionContent }}</legend>
            <div class="poi-grid">
              <div class="poi-field poi-field--half">
                <label class="poi-label" for="teaser">{{ options.Lang.poiTeaser }}</label>
                <textarea id="teaser" name="teaser" tabindex="2" class="poi-input poi-textarea"
                          :placeholder="options.Lang.poiTeaser" v-model="form.teaser"
                          :disabled="sending || !options.POIFormEditable"></textarea>
              </div>
              <div class="poi-field poi-field--half">
                <label class="poi-label" for="description">{{ options.Lang.poiDescription }}</label>
                <textarea id="description" name="description" tabindex="2" class="poi-input poi-textarea"
                          :placeholder="options.Lang.poiDescription" v-model="form.description"
                          :disabled="sending || !options.POIFormEditable"></textarea>
              </div>
              <div class="poi-field poi-field--half">
                <label class="poi-label" for="tipps">{{ options.Lang.poiTipp }}</label>
                <textarea id="tipps" name="tipps" tabindex="2" class="poi-input poi-textarea"
                          :placeholder="options.Lang.poiTippDescription" v-model="form.tipps"
                          :disabled="sending || !options.POIFormEditable"></textarea>
              </div>
              <div class="poi-field poi-field--half">
                <label class="poi-label" for="hinweis">{{ options.Lang.poiHinweis }}</label>
                <textarea id="hinweis" name="hinweis" tabindex="2" class="poi-input poi-textarea"
                          :placeholder="options.Lang.poiHinweisDescription" v-model="form.hinweis"
                          :disabled="sending || !options.POIFormEditable"></textarea>
              </div>
            </div>
          </fieldset>

          <!-- ===================== IMAGES ===================== -->
          <fieldset class="poi-section">
            <legend class="poi-section__title">{{ options.Lang.poiImage }}</legend>
            <div class="poi-grid">
              <div class="poi-field poi-field--third" v-for="n in 5" :key="'image' + n">
                <label class="poi-label" :for="'image' + n">{{ options.Lang.poiImage }} {{ n }}</label>
                <input
                    :id="'image' + n" :name="'image' + n" type="text" tabindex="2"
                    class="poi-input"
                    :placeholder="'http://poi-photo' + n + '.jpg'"
                    v-model="form['image' + n]"
                    :disabled="sending || !options.POIFormEditable" />
              </div>
            </div>
          </fieldset>

        </form>
      </md-dialog-content>

      <md-dialog-actions class="poi-dialog__actions">
        <md-button v-if="currentFormPOI" tabindex="-1" class="md-raised secondary poi-btn-delete" @click="rmvPOI()">
          <strong>{{ options.Lang.POI_löschen }}</strong>
        </md-button>
        <div class="poi-dialog__actions-right">
          <md-button tabindex="-1" class="md-raised secondary" @click="closeDialog">
            <strong>{{ options.Lang.Abbrechen }}</strong>
          </md-button>
          <md-button tabindex="-1" v-if="options.POIFormEditable" class="md-raised md-primary" @click="save">
            {{ options.Lang.Speichern }}
          </md-button>
          <md-button tabindex="-1" v-else class="md-raised md-primary" @click="openEdit">
            <strong>{{ options.Lang.POI_bearbeiten }}</strong>
          </md-button>
        </div>
      </md-dialog-actions>

      <Error class="errorDialog" v-if="options.showError && options.user.loggedIn" :options="options"></Error>
      <Success :options="options"></Success>

    </md-dialog>
  </template>
  
  <script>
  import {validationMixin} from 'vuelidate'
  import {
    required,
  } from 'vuelidate/lib/validators'
  import ImageUploader from 'vue-image-upload-resize'
  import Success from '../../components/dialogs/Success.vue'
  import Error from '../../components/dialogs/Error.vue'
  
  export default {
    name: 'formTemplate',
    mixins: [validationMixin],
    components: {
      ImageUploader, Success, Error
    },
    props: {
      options: {
        type: Object,
        required: true
      },
      currentFormPOI: {
        type: Object
      },
      maxId: {
        type: String,
        default: '0'  
      }
    },
    data: () => ({
      poi: {},
      showPwError: false,
      form: {
        address_line_1:null,
        address_line_2:null,
        city:null,
        coordinate:null,
        country:null,
        description:null,
        id:null,
        name:null,
        photos:null,
        practical_infos:null,
        state:null,
        teaser:null,
        zip_code:null,
        latitud:null,
        longitude:null,
        website:null,
        email:null,
        telephone:null,
        freeCall:null,
        openTimes:null,
        image1:null,
        image2:null,
        image3:null,
        image4:null,
        image5:null,
        tipps:null,
        hinweis:null
      },
      poiSaved: false,
      sending: false,
    }),
    validations: {
      form: {
        id: {
          required,
        },
        coordinate: {
          required,
        },
        name: {
          required,
        }
      }
    },
      
    mounted() {
      this.poi = this.currentFormPOI;
  
    },
    watch: {
      currentFormPOI: {
        handler(newValue) {
          if (newValue) {
            //console.log(this.options.userFormEditable);
            let self = this;
            self.poi = newValue ? newValue : null;
            self.form.id = newValue ? newValue.id : null;
            self.form.address_line_1 = newValue ? newValue.address_line_1 : null;
            self.form.address_line_2 = newValue ? newValue.address_line_2 : null;
            self.form.city = newValue ? newValue.city : null;
            self.form.coordinate = newValue ? newValue.coordinate : null;
            self.form.country = newValue ? newValue.country : null;
            self.form.description = newValue ? newValue.description : null;
            self.form.name = newValue ? newValue.name : null;
            self.form.photos = newValue ? newValue.photos : null;
            self.form.practical_infos = newValue ? newValue.practical_infos : null;
            self.form.state = newValue ? newValue.state : null;
            self.form.teaser = newValue ? newValue.teaser : null;
            self.zip_code = newValue ? newValue.zip_code : null;
            self.form.latitud = newValue ? self.getCoordinates(1): null;
            self.form.longitude = newValue ? self.getCoordinates(0) : null;
            self.getInformation()
          }
        },
        deep: true,
        immediate: true,
      }
    },
    methods: {
      async rmvPOI(){


        if(this.form.id == this.options.user.id){
          this.options.showError = true;
        }else{
          let self = this;
          await this.doPost({ data: self.form}, 'rmvPOI', function (res) {
          if (res.data.status === 'error') {
            self.help.log(self.$t(res.msg), false, true);
          } else {
            self.options.showPOIForm = false;
            self.$nextTick(function(){
              window.location = "/pois";
            })
          }
        });
        }
      },
      getValidationClass(fieldName) {
        const field = this.$v.form[fieldName]
  
        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },
      clearForm() {
        this.$v.$reset()
        this.form.id = null
        this.form.address_line_1 = null
        this.form.address_line_2 = null
        this.form.city = null
        this.form.coordinate = null
        this.form.country = null
        this.form.description = null
        this.form.name = null
        this.form.photos = null
        this.form.practical_infos = null
        this.form.state = null
        this.form.teaser = null
        this.form.zip_code = null
        this.form.latitud = null
        this.form.longitude = null
        this.form.website = null;
        this.form.email = null;
        this.form.telephone = null;
        this.form.freeCall = null;
        this.form.openTimes = null;
        this.form.image1 = null;
        this.form.image2 = null;
        this.form.image3 = null;
        this.form.image4 = null;
        this.form.image5 = null;
        this.form.tipps = null;
        this.form.hinweis = null;
        this.showPwError = false
      },
      save() {
        const self = this;
        self.$v.$touch()
        if (!self.form.name || !self.form.coordinate) {
          self.showPwError = true;
          return false;
        }
        self.form.coordinate = `(${self.form.longitude}, ${self.form.latitud})`
        if (!self.form.id) {
           self.form.id = self.maxId
        }
        this.setPracticalInfoAndPhotos()
       
        self.sending = true;
        this.doPost({
          userdata: self.options.user,
          data: self.form
        }, self.currentFormPOI ? 'updatePOIById' : 'createPOI', function (res) {
          self.sending = false;
          if (res.data.status === 'error') {
            self.help.log(self.$t(res.msg), false, true);
          } else {
            self.options.showSuccess = true;
            self.$emit('updateData', {});
            self.closeDialog();
          }
        });
      },
      openEdit() {
        this.options.POIFormEditable = true;
      },
      openDialog() {
  
      },
      closeDialog() {
        this.clearForm();
        this.options.showPOIForm = false;
        this.options.currentFormPOI = null;
        this.options.POIFormEditable = true;
      },
      validate() {
        this.$v.$touch()
  
        if (!this.$v.$invalid) {
          this.save()
        }
      },
      getCoordinates(pos){
        let coordinateArray = this.form.coordinate?.replace(/[()]/g, "").split(", ");
        return coordinateArray[pos]
      },
      getInformation(){
        let practicalInfos = this.form.practical_infos;
              
        let websites = [];
        let emails = [];
        let freeCalls = []
        let telephones = []
        let hinweises = []
        let tippes = []
        const regex = /(E-Mail|Free-Call|Öffnungszeiten|Tel\.|Website|Tipp|Hinweis|Kunden-Tipp)\|([^,]*(, (?!(E-Mail|Free-Call|Öffnungszeiten|Tel\.|Website|Tipp|Hinweis|Kunden-Tipp))[^,]*)*)/g;
        let match;
        while ((match = regex.exec(practicalInfos)) !== null) {
          switch (match[1]) {
            case 'Website':
              websites.push(match[2].trim());
              break;
            case 'Free-Call':
              freeCalls.push(match[2].trim())
              break;
            case 'Tel.':
              telephones.push(match[2].trim())
              break;
            case 'Öffnungszeiten':
              this.form.openTimes = match[2].trim();
              break;
            case 'E-Mail':
              emails.push(match[2].trim())
              break;
            case 'Tipp':
              tippes.push(match[2].trim())
              break;
            case 'Kunden-Tipp':
              tippes.push(match[2].trim())
              break;
            case 'Hinweis':
              hinweises.push(match[2].trim())
              break;
          }
        }

        if (websites.length > 0) {
          this.form.website = websites.join(', ');
        }

        if (emails.length > 0) {
          this.form.email = emails.join(', ');
        }

        if (freeCalls.length > 0) {
          this.form.freeCall = freeCalls.join(', ');
        }

        if (telephones.length > 0) {
          this.form.telephone = telephones.join(', ');
        }

        if (hinweises.length > 0) {
          this.form.hinweis = hinweises.join('| ');
        }

        if (tippes.length > 0) {
          this.form.tipps = tippes.join('| ');
        }

        

        let photoElements = this.form.photos.split(', ');
        let imageExtensionRegex = /https?:\/\/.*\.(jpg|jpeg|png|gif)$/i;
        if (photoElements) {
          let count = 1
          photoElements.forEach((photo,index) => {
            const matches = photo.match(imageExtensionRegex);

            if (matches && matches[0]) {
              this.form[`image${count}`] = matches[0];
              count++
            }

          })
        }

      },
      setPracticalInfoAndPhotos(){
        let form = this.form

        let practicalInfos = ''

        if (form.website) {
          let dataElement = form.website.split(', ');
          dataElement.forEach(element=>{
            practicalInfos +=  `Website|${element}, `
          })
        }

        if (form.email) {
          let dataElement = form.email.split(', ');
          dataElement.forEach(element=>{
            practicalInfos +=  `E-Mail|${element}, `
          })
        }

        if (form.telephone) {
          let dataElement = form.telephone.split(', ');
          dataElement.forEach(element=>{
            practicalInfos +=  `Tel.|${element}, `
          })
        }

        if (form.freeCall) {
          let dataElement = form.freeCall.split(', ');
          dataElement.forEach(element=>{
            practicalInfos +=  `Free-Call|${element}, `
          })
        }

        if (form.openTimes) {
          practicalInfos +=  `Öffnungszeiten|${form.openTimes}, `
        }

        if (form.tipps) {
          let dataElement = form.tipps.split('|');
          dataElement.forEach(element=>{
            practicalInfos +=  `Tipp|${element}, `
          })
        }

        if (form.hinweis) {
          let dataElement = form.hinweis.split('|');
          dataElement.forEach(element=>{
            practicalInfos +=  `Hinweis|${element}, `
          })
        }

        if (practicalInfos.endsWith(', ')) {
          practicalInfos = practicalInfos.slice(0, -2);
        }

        if (practicalInfos !== '') {
          form.practical_infos = practicalInfos
        }

        let photosString = ''
        if (form.image1) {
          photosString +=  `${form.image1}, `
        }
        if (form.image2) {
          photosString +=  `${form.image2}, `
        }
        if (form.image3) {
          photosString +=  `${form.image3}, `
        }
        if (form.image4) {
          photosString +=  `${form.image4}, `
        }
        if (form.image5) {
          photosString +=  `${form.image5}, `
        }

        if (photosString.endsWith(', ')) {
          photosString = photosString.slice(0, -2);
        }

        if (photosString !== '') {
          form.photos = photosString
        }


      },
      
    },
  }
  </script>
    <style lang="scss" scoped>
  /* ---------- dialog shell ---------- */
  .poi-dialog ::v-deep .md-dialog-container,
  .poi-dialog ::v-deep .md-dialog {
    max-width: 1100px;
    width: 92vw;
  }

  /* md-dialog-title is a child component, so its own (unscoped) vue-material
     padding/margin beats a plain scoped rule — hence ::v-deep + !important. */
  .poi-dialog ::v-deep .poi-dialog__title,
  .poi-dialog ::v-deep .md-dialog-title {
    display: block;
    margin: 0 0 4px !important;
    padding: 26px 32px 18px !important;
    font-size: 22px;
    font-weight: 600;
    line-height: 1.3;
    color: #1f2430;
    border-bottom: 1px solid #e8eaf0;
  }

  .poi-dialog ::v-deep .poi-dialog__content,
  .poi-dialog ::v-deep .md-dialog-content {
    padding: 12px 32px 4px !important;
    overflow-y: auto;
  }

  /* ---------- form ---------- */
  .poi-form {
    padding: 8px 0 4px;
  }

  .poi-section {
    border: 0;
    margin: 0 0 28px;
    padding: 0;
  }

  .poi-section:last-of-type {
    margin-bottom: 8px;
  }

  .poi-section__title {
    padding: 0;
    margin-bottom: 14px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #8a90a2;
  }

  /* 12-column grid: every field sits on the same baseline, so rows line up */
  .poi-grid {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: 18px 20px;
  }

  .poi-field {
    display: flex;
    flex-direction: column;
    min-width: 0;
    grid-column: span 12;
  }

  .poi-field--half    { grid-column: span 6; }
  .poi-field--third   { grid-column: span 4; }
  .poi-field--quarter { grid-column: span 3; }

  .poi-label {
    margin-bottom: 6px;
    font-size: 13px;
    font-weight: 500;
    color: #4a5065;
    line-height: 1.2;
  }

  .poi-required {
    margin-left: 2px;
    color: #e53935;
  }

  /* ---------- inputs (plain, no vue-material) ---------- */
  .poi-input {
    width: 100%;
    box-sizing: border-box;
    height: 42px;
    padding: 0 12px;
    font-family: inherit;
    font-size: 14px;
    color: #1f2430;
    background-color: #f5f6fa;
    border: 1px solid #dfe2ea;
    border-radius: 6px;
    outline: none;
    transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;
  }

  .poi-input::placeholder {
    color: #a9aebd;
  }

  .poi-input:hover:not(:disabled) {
    border-color: #c6cbd8;
  }

  .poi-input:focus {
    background-color: #fff;
    border-color: #2f6fed;
    box-shadow: 0 0 0 3px rgba(47, 111, 237, 0.12);
  }

  .poi-input:disabled {
    color: #6b7185;
    -webkit-text-fill-color: #6b7185;
    background-color: #eceef4;
    cursor: not-allowed;
  }

  .poi-textarea {
    height: 132px;
    padding: 10px 12px;
    line-height: 1.5;
    resize: vertical;
    overflow-y: auto;
  }

  /* ---------- validation ---------- */
  .poi-input--error {
    border-color: #e53935;
    background-color: #fff5f5;
  }

  .poi-input--error:focus {
    border-color: #e53935;
    box-shadow: 0 0 0 3px rgba(229, 57, 53, 0.12);
  }

  .poi-error {
    margin-top: 5px;
    font-size: 12px;
    color: #e53935;
  }

  /* ---------- footer ---------- */
  .poi-dialog ::v-deep .poi-dialog__actions,
  .poi-dialog ::v-deep .md-dialog-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 32px 20px !important;
    margin-top: 8px;
    border-top: 1px solid #e8eaf0;
  }

  /* keep Save/Cancel right-aligned even when Delete is absent */
  .poi-dialog__actions .poi-btn-delete {
    margin-right: auto;
  }

  .poi-dialog__actions-right {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: auto;
  }

  /* ---------- responsive ---------- */
  @media (max-width: 900px) {
    .poi-field--half,
    .poi-field--third,
    .poi-field--quarter {
      grid-column: span 6;
    }
  }

  @media (max-width: 600px) {
    .poi-dialog ::v-deep .poi-dialog__title,
    .poi-dialog ::v-deep .md-dialog-title {
      padding: 20px 20px 14px !important;
      font-size: 19px;
    }
    .poi-dialog ::v-deep .poi-dialog__content,
    .poi-dialog ::v-deep .md-dialog-content {
      padding: 10px 20px 4px !important;
    }
    .poi-dialog__actions { padding: 14px 20px 18px; }

    .poi-field--half,
    .poi-field--third,
    .poi-field--quarter {
      grid-column: span 12;
    }
  }
  </style>
